<template>
  <div>
    <feather-icon icon="Edit3Icon" v-if="params.data.status == 'T'" title="Düzenleme" svgClasses="h-5 w-5 mr-5 hover:text-primary cursor-pointer" @click="editRecord" />
    <feather-icon icon="Trash2Icon" v-if="params.data.status == 'T'" title="Silme" svgClasses="h-5 w-5 mr-5  hover:text-danger cursor-pointer" @click="visible = true" />

    <feather-icon icon="CheckCircleIcon" v-if="params.data.status == 'T'" title="Onaylama" svgClasses="h-5 mr-5 hover:text-danger cursor-pointer" @click="purchaseUpdateStatus(params.data.purchaseId, 'O')" />

    <feather-icon icon="CreditCardIcon" v-if="params.data.status == 'O'" title="Mal Kabul" svgClasses="h-5 w-5 mr-5 hover:text-primary cursor-pointer" @click="purchaseReceive" />

    <feather-icon icon="SearchIcon" v-if="params.data.status == 'O'" title="Kaydı İncele" svgClasses="h-5 w-5 mr-5 hover:text-primary cursor-pointer" @click="editRecord" />

    <!-- <feather-icon icon="ActivityIcon" title="Gider Muhasebeye Kaydı Oluştur" svgClasses="h-5 w-5 mr-5 hover:text-primary cursor-pointer" @click="createSupplierTransaction" /> -->

    <vs-prompt vs-title="Talep Sil" vs-button-cancel="border" vs-cancel-text="Vazgeç" vs-accept-text="Sil" @vs-close="cancel" @vs-cancel="cancel" @vs-accept="deleteRecord(params.data.purchaseId)" vs-color="danger" :vs-active.sync="visible">
      <div class="vx-row ml-5 mr-5">
        <p>{{ params.data.purchaseId }} numaralı talebi silmek istiyor musunuz ?</p>
      </div>
    </vs-prompt>

    <feather-icon v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '7') != null" icon="DollarSignIcon" title="Maliyet Bilgisi Ekle" svgClasses="h-5 w-5 mr-5 hover:text-primary cursor-pointer" @click="ownCost" />

    <vs-popup title=" Maliyet Ekleme (Maliyetleri TL olarak giriniz) " :active.sync="popupOwnCost">
      <div style="display: -webkit-inline-box; width: 100%;">
        <div style="width: 30%;">
          <label style="vertical-align: -webkit-baseline-middle;">
            <b>Navlun Masrafı</b>
          </label>
        </div>
        <div style="width: 45%; text-align: -webkit-right;">
          <vs-input size="small" type="number" v-model="params.data.freightExpense" />
        </div>
        <div style="width: 5%; text-align: -webkit-right;">
          <label style="vertical-align: -webkit-baseline-middle;">
            <b> TL</b>
          </label>
        </div>
      </div>
      <div style="display: -webkit-inline-box; width: 100%;">
        <div style="width: 30%;">
          <label style="vertical-align: -webkit-baseline-middle;">
            <b>Vergi Tutarı</b>
          </label>
        </div>
        <div style="width: 45%; text-align: -webkit-right;">
          <vs-input size="small" type="number" v-model="params.data.customsTariff" />
        </div>
        <div style="width: 5%; text-align: -webkit-right;">
          <label style="vertical-align: -webkit-baseline-middle;">
            <b> TL</b>
          </label>
        </div>
      </div>

      <div style="display: -webkit-inline-box; width: 100%;">
        <div style="width: 30%;">
          <label style="vertical-align: -webkit-baseline-middle;">
            <b>Vergi Masrafları</b>
          </label>
        </div>
        <div style="width: 45%; text-align: -webkit-right;">
          <vs-input size="small" type="number" v-model="params.data.customsExpense" />
        </div>
        <div style="width: 5%; text-align: -webkit-right;">
          <label style="vertical-align: -webkit-baseline-middle;">
            <b> TL</b>
          </label>
        </div>
      </div>

      <div style="display: -webkit-inline-box; width: 100%;">
        <div style="width: 30%;">
          <label style="vertical-align: -webkit-baseline-middle;">
            <b>Kargo Masrafı</b>
          </label>
        </div>
        <div style="width: 45%; text-align: -webkit-right;">
          <vs-input size="small" type="number" v-model="params.data.deliveryOrderExpense" />
        </div>
        <div style="width: 5%; text-align: -webkit-right;">
          <label style="vertical-align: -webkit-baseline-middle;">
            <b> TL</b>
          </label>
        </div>
      </div>

      <div style="display: -webkit-inline-box; width: 100%;">
        <div style="width: 30%;">
          <label style="vertical-align: -webkit-baseline-middle;">
            <b>Depolama Masrafı</b>
          </label>
        </div>
        <div style="width: 45%; text-align: -webkit-right;">
          <vs-input size="small" type="number" v-model="params.data.warehouseExpense" />
        </div>
        <div style="width: 5%; text-align: -webkit-right;">
          <label style="vertical-align: -webkit-baseline-middle;">
            <b> TL</b>
          </label>
        </div>
      </div>

      <div style="display: -webkit-inline-box; width: 100%;">
        <div style="width: 30%;">
          <label style="vertical-align: -webkit-baseline-middle;">
            <b>Yurtiçi Kargo Masrafı</b>
          </label>
        </div>

        <div style="width: 45%; text-align: -webkit-right;">
          <vs-input size="small" type="number" v-model="params.data.domesticTranportationExpense" />
        </div>
        <div style="width: 5%; text-align: -webkit-right;">
          <label style="vertical-align: -webkit-baseline-middle;">
            <b> TL</b>
          </label>
        </div>
      </div>

      <div style="display: -webkit-inline-box; width: 100%;">
        <div style="width: 30%;">
          <label style="vertical-align: -webkit-baseline-middle;">
            <b>Ekstra Masraflar</b>
          </label>
        </div>
        <div style="width: 45%; text-align: -webkit-right;">
          <vs-input size="small" type="number" v-model="params.data.extraExpense" />
        </div>
        <div style="width: 5%; text-align: -webkit-right;">
          <label style="vertical-align: -webkit-baseline-middle;">
            <b> TL</b>
          </label>
        </div>
      </div>

      <div style="width: 100%; text-align-last: center;">
        <vs-button class="mb-4 md:mb-0 mr-4 mt-5" style="width: 75%;" @click="addExpenseToPurchase()">Kaydet</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";

export default {
  data() {
    return {
      visible: false,
      popupOwnCost: false,
      purchaseTotalAmountList: [],
    };
  },
  name: "CellRendererActions",
  methods: {
    editRecord() {
      this.$router.push("../Purchase/" + this.params.data.purchaseId);
    },

    purchaseReceive() {
      if (this.params.data.status == "O") {
        this.$router.push("../Purchase/purchaseReceive/" + this.params.data.purchaseId).catch(() => {});
      } else {
        this.$vs.notify({
          color: "danger",
          icon: "warning",
          title: "Hata!",
          text: `Sadece durumu Onaylandı statüsündeki kayıtlar mal kabule gidebilir`,
        });
      }
    },

    addExpenseToPurchase: async function() {
      console.log(this.params.data);

      if (this.params.data.status == "O") {
        let r = await repository.postEntity("Purchase/addExpenseToPurchase", this.params.data);

        if (r && r.isSuccessful) {
          this.popupOwnCost = false;
          (await this.$swal.fire(`${this.params.data.purchaseId} Talep Nolu Talep Masrafları Başarıyla Kaydedildi.`)).isConfirmed(() => {
            location.reload();
          });
        } else {
          this.$vs.notify({
            color: "danger",
            icon: "warning",
            title: "Hata!",
            text: `"${this.params.data.purchaseId}" Masraf işlemi tamamlanamadı`,
          });
        }
      } else {
        this.$vs.notify({
          color: "danger",
          icon: "warning",
          title: "Hata!",
          text: `Sadece durumu Talep Onaylandı statüsündeki kayıtlar için masraf girilebilir`,
        });
      }
    },

    ownCost() {
      // if (this.params.data.status == "O") {
      //   this.$router.push("../Purchase/purchaseReceive2/" + this.params.data.purchaseId).catch(() => {});
      // } else {
      //   this.$vs.notify({
      //     color: "danger",
      //     icon: "warning",
      //     title: "Hata!",
      //     text: `Sadece durumu Onaylandı statüsündeki kayıtlar mal kabule gidebilir`,
      //   });
      // }

      this.popupOwnCost = true;
    },

    cancel() {
      this.visible = false;
    },

    purchaseUpdateStatus: async function(purchaseId, status) {
      let resultConfirm = null;
      //1 Numaralı tedarikçi Nitro mekatronik.
      if (status == "O" && this.params.data.purchaseDetail[0].supplierId != 1) {
        await this.$vs.loading();
        this.purchaseTotalAmountList = await repository.postEntity("Purchase/GetPurchaseTotalAmountList", { purchaseId: purchaseId }).then((r) => r.list);
        await this.$vs.loading.close();

        let textMessage = `${this.purchaseTotalAmountList[0].supplierName} isimli tedarikçinin ( Müşteri Id = ${this.purchaseTotalAmountList[0].supplierId} )  hesabına ${this.purchaseTotalAmountList[0].totalAmount} ${this.purchaseTotalAmountList[0].currencyName} tutarında ödeme yapılacaktır. `;

        resultConfirm = await this.$swal.fire({
          icon: "warning",
          title: "Devam etmek istediğinize emin misiniz?",
          text: textMessage,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Evet",
          cancelButtonText: "Hayır",
        });
      } else {
        resultConfirm = await this.$swal.fire({
          icon: "warning",
          title: "Devam etmek istediğinize emin misiniz?",
          //text: "Devam etmek istediğinize emin misiniz?",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Evet",
          cancelButtonText: "Hayır",
        });
      }

      if (resultConfirm.isConfirmed) {
        null;
      } else {
        return;
      }

      if (this.params.data.status == "T") {
        let purchaseUpdateStatusModel = {
          purchaseId: purchaseId,
          status: status,
          supplierId: this.params.data.purchaseDetail[0].supplierId,
        };

        let r = await repository.postEntity("Purchase/purchaseUpdateStatus", purchaseUpdateStatusModel);

        if (r && r.isSuccessful) {
          await this.$swal.fire(`${this.params.data.purchaseId} Nolu Talep Başarıyla Onaylandı.`);
          this.params.context.componentParent.getPurchaseList();
        } else {
          this.$vs.notify({
            color: "danger",
            icon: "warning",
            title: "Hata!",
            text: `"${this.params.data.purchaseId}" onaylama işlemi tamamlanamadı`,
          });
        }
      } else {
        this.$vs.notify({
          color: "danger",
          icon: "warning",
          title: "Hata!",
          text: `Sadece durumu Talep Oluşturuldu statüsündeki kayıtlar onaylanabilir`,
        });
      }
    },

    deleteRecord: async function(purchaseId) {
      if (this.params.data.status == "T") {
        let r = await repository.deleteWithParam("purchase/purchaseDelete?purchaseId", purchaseId);

        if (r && r.isSuccessful) {
          await this.$swal.fire(`"${this.params.data.purchaseId}" Başarıyla Silindi.`);
          this.params.context.componentParent.getPurchaseList();
        } else {
          this.$vs.notify({
            color: "danger",
            icon: "warning",
            title: "Hata!",
            text: `"${this.params.data.purchaseId}" silme işlemi tamamlanamadı`,
          });
        }
      } else {
        this.$vs.notify({
          color: "danger",
          icon: "warning",
          title: "Hata!",
          text: `Sadece durumu Talep Oluşturuldu statüsündeki kayıtlar silinebilir`,
        });
      }
    },
  },
};
</script>
